export default __webpack_public_path__ + "static/IN-9408-vs-IN-9008_WA_resTestBig-6376b59fa4a0d7070ef505a66eaae597.webp";